module.exports = __webpack_public_path__ + "img/siti.c5235caa.png";